<app-title-section></app-title-section>

<app-parametre-bar
  [initialSettings]="documentColumnSettings"
  documentType="facture"
  (primaryColorChange)="onPrimaryColorChange($event)"
  (documentSettingsChange)="onDocumentSettingsChange($event)"
></app-parametre-bar>

<div class="card p-1 lc-facture-detail-page" [style.margin]="'0 60px'">
  <div *ngIf="loading" class="text-center p-5">
    <span class="spinner-border text-primary" role="status"></span>
    <p class="text-muted mt-2 mb-0">Chargement du document…</p>
  </div>

  <ng-container *ngIf="!loading">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <img [src]="stationLogo" class="logo-img me-2" style="width: 35px; height: auto" alt="Logo" />
        <p style="font-size: 22px; color: #2f2b3de5">{{ stationName }}</p>
      </div>
      <label>
        <strong class="size20">FACTURE / </strong>
        <label class="text-muted size20">{{ numDocument }}</label>
        <span *ngIf="isEditable" class="badge bg-light-warning ms-2">Brouillon</span>
      </label>
    </div>

    <div class="items mt-4 d-flex flex-wrap gap-4">
      <div style="min-width: 280px; flex: 1">
        <p style="font-size: 15px; color: #2f2b3de5; font-weight: 700">Client</p>
        <hr class="section-line" [style.border-bottom]="'1px solid ' + primaryColor" />
        <ng-container *ngIf="showClientPicker">
          <ng-select
            class="filter-ng-select lc-facture-client-select"
            [items]="clientOptions"
            bindLabel="label"
            bindValue="id"
            [(ngModel)]="selectedClientId"
            (ngModelChange)="onClientSelected($event)"
            placeholder="Choisir un client"
            [loading]="loadingClients"
            [clearable]="false"
          ></ng-select>
          <p class="text-muted small mt-1 mb-0" *ngIf="!loadingClients && clientOptions.length === 0">
            Aucun client disponible
          </p>
        </ng-container>
        <ng-container *ngIf="!showClientPicker">
          <p class="mb-1">{{ clientLabel }}</p>
          <p class="text-muted mb-0" *ngIf="clientPhone !== '—'">{{ clientPhone }}</p>
        </ng-container>
      </div>
      <div style="min-width: 280px; flex: 1">
        <p style="font-size: 15px; color: #2f2b3de5; font-weight: 700">Détails du document</p>
        <hr class="section-line" [style.border-bottom]="'1px solid ' + primaryColor" />
        <p class="mb-1"><strong>Date :</strong> {{ documentDate }}</p>
        <p class="mb-1"><strong>Établissement :</strong> {{ entrepotLabel }}</p>
        <p class="mb-1" *ngIf="documentOriginalLabel !== '—'">
          <strong>Tickets liés :</strong> {{ documentOriginalLabel }}
        </p>
        <p class="mb-0"><strong>Statut :</strong> {{ documentStatut }}</p>
      </div>
    </div>

    <div class="mt-4" *ngIf="sourceTickets.length">
      <p style="font-size: 15px; color: #2f2b3de5; font-weight: 700">Tickets source</p>
      <div class="table-responsive">
        <table class="table table-sm table-hover mb-0">
          <thead>
            <tr>
              <th>Numéro ticket</th>
              <th>Date</th>
              <th>Établissement</th>
              <th>Statut</th>
              <th>Client</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of sourceTickets">
              <td>{{ t.numero }}</td>
              <td>{{ t.date }}</td>
              <td>{{ t.entrepot }}</td>
              <td>{{ t.statut }}</td>
              <td>{{ t.client }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="products-section mt-4">
      <table class="products-table">
        <thead [style.height]="'56px'" [style.backgroundColor]="getColorWithOpacity(0.16)">
          <tr>
            <th>DÉSIGNATION / RÉFÉRENCE</th>
            <th *ngIf="documentColumnSettings.quantite">QUANTITÉ</th>
            <th *ngIf="documentColumnSettings.prixUnitaire">VALEUR UNITAIRE</th>
            <th>TOTAL HT</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="ligneRows.length === 0">
            <td [attr.colspan]="isEditable ? 4 : 4" class="text-center text-muted">Aucun article</td>
          </tr>
          <tr *ngFor="let ligne of ligneRows">
            <td class="approve-ligne-cel approve-ligne-cel--stack">
              <div class="approve-ligne-cel__main">{{ ligne.libelle }} / {{ ligne.reference }}</div>
              <div class="approve-ligne-cel__sub" *ngIf="ligne.couleurTaille !== '—'">
                {{ ligne.couleurTaille }}
              </div>
            </td>
            <td *ngIf="documentColumnSettings.quantite">
              <span>{{ ligne.quantite }}</span>
            </td>
            <td *ngIf="documentColumnSettings.prixUnitaire">
              <span>{{ formatPrice(ligne.prixUnitaire) }} TND</span>
            </td>
            <td>{{ formatPrice(ligne.totalHt) }} TND</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <table class="table table-borderless text-start rounded totals-table" style="max-width: 400px">
        <tbody>
          <tr><td>Total HT</td><td>{{ totals.totalHT | number:'1.3-3' }} TND</td></tr>
          <tr><td>Total TVA</td><td>{{ totals.totalTVA | number:'1.3-3' }} TND</td></tr>
          <tr><td>Total TTC</td><td>{{ totals.totalTTC | number:'1.3-3' }} TND</td></tr>
          <tr><td>Timbre fiscal</td><td>{{ totals.timbreFiscal | number:'1.3-3' }} TND</td></tr>
          <tr class="fw-bold"><td>Net à payer</td><td>{{ totals.netAPayer | number:'1.3-3' }} TND</td></tr>
        </tbody>
      </table>
    </div>

  </ng-container>
</div>
